import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectChatsState } from "../store/chats/selectors";
import { fetchCasesByConversationId } from "../store/chats/thunks";

export const useCases = ({ fetch = true, chatId = null } = {}) => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { chatsByTenants, selectedChatId } = useSelector(selectChatsState);
  const effectiveChatId = chatId || selectedChatId;

  const selectedChat = useMemo(() => {
    return chatsByTenants?.[selectedTenantId]?.[effectiveChatId];
  }, [effectiveChatId, selectedTenantId, chatsByTenants]);

  useEffect(() => {
    if (
      fetch &&
      effectiveChatId &&
      !selectedChat?.cases &&
      !selectedChat?.casesLoading
    ) {
      dispatch(
        fetchCasesByConversationId({
          conversation_id: selectedChat?.id,
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [fetch, selectedTenantId, effectiveChatId, selectedChat, dispatch]);

  return {
    loading: selectedChat?.casesLoading,
    cases: selectedChat?.cases || [],
    selectedTenantId,
    selectedChatId: effectiveChatId,
  };
};
